import { i18nNsFactory } from '@atlas-frontend/i18n';
import {
  DataObjectGroupProcessingStateType,
  Tooltip,
} from '@atlas-frontend/sdk';
import translations from './CollectionRatio.translations.json';

const { addTranslations, t } = i18nNsFactory('collection-ratio');
addTranslations(translations);

export const CollectionRatio: React.FC<{
  processingState: DataObjectGroupProcessingStateType;
}> = ({ processingState }) => {
  const { subjectCountInData, subjectCountInSample, collectionRatio } =
    processingState;

  if (collectionRatio === null) {
    return null;
  }

  return (
    <Tooltip
      title={t('tooltip', {
        dataCount: subjectCountInData,
        sampleCount: subjectCountInSample,
      })}
    >
      <span>{Math.round(collectionRatio * 100)}%</span>
    </Tooltip>
  );
};
